import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
const packets = {
    state: () => ({
        items: [],
        filter: {
            searchTerm: null,
            skip: 0,
            take: 200,
            total: 0,
            page: 1,
        },
        selectedItems: [],
        loading: true,
    }),
    mutations: {
        setPackets(state, payload) {
            state.items = payload.items;
            state.filter.total = payload.total;
        },
        setSelectedPackets(state, payload) {
            state.selectedItems = payload;
        },
        setPacketPage(state, payload) {
            state.filter.page = payload;
        },
        setPacketTake(state, payload) {
            state.filter.page = 1;
            state.filter.take = payload;
        },
    },
    actions: {
        // async getPackets(store) {
        //     store.state.loading = true;
        //     await axios
        //         .post("packet/load", {
        //             ...store.state.filter,
        //             skip: (store.state.filter.page - 1) * store.state.filter.take,
        //         })
        //         .then((res) => {
        //             store.state.loading = false;
        //             return store.commit("setPackets", res.data.data);
        //         });
        // },
        async togglePacket(store, payload) {
            var res = await axios.post("packet/toggleisactive", {
                id: store.state.items[payload.index].id,
            });
            return res.data;
        },
        async deletePacket(store, payload) {
            await axios
                .post("packet/delete", {
                    id: store.state.items[payload.index].id,
                })
                .then((res) => {
                    if (res.data.alert.hasError) {
                        payload.context.$message.error(res.data.alert.message);
                    } else {
                        store.state.items.splice(payload.index, 1);
                        payload.context.$message.success(res.data.alert.message);
                        if (store.state.items.length == 0 && store.state.filter.page != 1) {
                            this.commit("setPacketPage", store.state.filter.page - 1);
                        }
                        store.state.filter.total = store.state.filter.total - 1;
                    }
                });
        },
    },
    getters: {},
};
export default packets;


// WEBPACK FOOTER //
// ./src/store/packets.js